import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';

export default class FestivalScheduleMobileCategoryEvents extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    showCategoryId: '',
    descriptionOpenId: 0
  }

  handleCategoryClick = (id) => {
    this.state.showCategoryId != id ? this.setState({showCategoryId: id}) :
    this.setState({showCategoryId: 0})
  }

  handleHeaderClick = (id) => {
    if (this.state.descriptionOpenId == id) {
      this.setState({descriptionOpenId: 0})
    } else {
      this.setState({descriptionOpenId: id})
    }
  }

  render() {

    if (!this.props.girlsFestivalCategoryEvents.isLoaded) {
      return <span />
    }

    let categoryEvents = this.props.girlsFestivalCategoryEvents;
    let categoryEventsList = '';
    let eventsList = '';
    let bannerImg = '';
    let hostedBy = '';
    let title = '';
    let time = '';
    let iconClasses = '';
    let eventDescription = '';

    let categoryClass = '';




    categoryEventsList = categoryEvents.categoryObjs.map((category, index) => {

      eventsList = category.events.map((event, index) => {

        iconClasses = classnames({
          'fa': true,
          'fa-chevron-up': this.state.descriptionOpenId == event.id,
          'fa-chevron-down': this.state.descriptionOpenId != event.id
        });

        if (this.state.descriptionOpenId == event.id) {
          eventDescription = <div className="festivalSchedule-eventDescription" dangerouslySetInnerHTML={{ __html: event.description }}></div>;
        } else {
          eventDescription = '';
        }

        if (event.bannerUrl !== '') {
          bannerImg = <div className="festivalSchedule-eventBanner"><img src={event.bannerUrl} /></div>
        } else {
          bannerImg = '';
        }

        if (event.hostedBy != '') {
          title = <div onClick={this.handleHeaderClick.bind(this, event.id)} style={{marginBottom: '0.5rem'}} className="festivalSchedule-eventTitle">{event.title} <i className={iconClasses}></i></div>

          hostedBy = <div className="festivalSchedule-eventHostedBy">Hosted by: {event.hostedBy}</div>;
        } else {
          title = <div onClick={this.handleHeaderClick.bind(this, event.id)} style={{marginBottom: '1.5rem'}} className="festivalSchedule-eventTitle">{event.title} <i className={iconClasses}></i></div>

          hostedBy = '';
        }

        if (event.is_allDay) {
          time = <div className="festivalSchedule-eventTime">All Day</div>
        } else {
          time = <div className="festivalSchedule-eventTime">{event.start_time}-{event.end_time}</div>
        }

        return <div key={`event-${index}-${event.id}`} className="festivalSchedule-eventCard">
          {bannerImg}
          {title}
          {hostedBy}

          {eventDescription}

          <div className="festivalSchedule-eventLocation">{event.building} &mdash; Room: {event.room}</div>

          {time}
        </div>;
      })

      if (category.id == this.state.showCategoryId) {
        categoryClass = 'show';
      } else {
        categoryClass = 'hide';
      }

      // Don't show Interactive Exhibits and PSA Video Contest since neither are events
      if (category.name == 'Interactive Exhibits' || category.name == 'PSA Video Contest') {
        return;
      } else {
        return <div key={`category-${index}-${category.id}`} className="festivalSchedule-categoryEventsWrapper">
          <div onClick={this.handleCategoryClick.bind(this, category.id)} className="festivalSchedule-category">{category.name}</div>
            <div className={`festivalSchedule-eventsWrapper ${categoryClass}`}>
              {eventsList}
            </div>

        </div>;
      }


    });

    return(
      <div>
        {categoryEventsList}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/festival/schedule/FestivalScheduleMobileCategoryEvents.jsx